import { ComponentType, memo } from 'react';
import { deepEquals } from 'utils/deepEquals';

export function withMemo<T>(Component: T): T {
  return memo(Component as unknown as ComponentType<T>, deepEquals) as unknown as T;
}
